module.exports = __webpack_public_path__ + "assets/roboto-regular.f0a2f833e85e8915420552c86a0f6cae837de8c618b38d0e4e41740080b0eb34.woff2";